import { Box, ListItemIcon, MenuItem } from '@mui/material'
import { FloatingMenuItemLabel } from './FloatingMenuItemLabel'
import { getMenuItemSx } from './getMenuItemSx'
import styles from './index.module.scss'

/**
 * @param {{
 *   item: { id: string, label: string, Icon?: import('react').ComponentType, variant?: string, selected?: boolean, disabled?: boolean },
 *   reserveIconSpace: boolean, onItemSelect?: (id: string) => false | void, onClose: () => void,
 * }} props
 */
export function FloatingMenuItem({ item, reserveIconSpace, onItemSelect, onClose }) {
  const ItemIcon = item.Icon
  const showIconColumn = reserveIconSpace || Boolean(ItemIcon)
  const isDanger = item.variant === 'danger'
  const isSelected = Boolean(item.selected)
  const isDisabled = Boolean(item.disabled)

  return (
    <MenuItem
      key={item.id}
      data-menu-item-id={item.id}
      disabled={isDisabled}
      onClick={() => {
        if (isDisabled) return
        if (onItemSelect?.(item.id) !== false) onClose()
      }}
      className={styles.item}
      sx={(theme) => getMenuItemSx(theme, { showIconColumn, isDisabled, isDanger, isSelected })}
    >
      {showIconColumn ? (
        <ListItemIcon className={styles.itemIconWrap} sx={{ minWidth: '18px', width: '18px', height: '18px', color: 'inherit' }}>
          {ItemIcon ? <ItemIcon className={styles.itemIcon} aria-hidden /> : <Box className={styles.itemIconSpacer} aria-hidden />}
        </ListItemIcon>
      ) : null}
      <FloatingMenuItemLabel label={item.label} isDanger={isDanger} isSelected={isSelected} />
    </MenuItem>
  )
}
